import gql from 'graphql-tag'

export default gql`mutation updateInvoice($data: InvoiceInput!) {
    updateInvoice(data: $data) @client
}`